import { useState } from 'react'
import zapierApi from '@/infrastructure/api/zapier'
import ReferralsApi from '@/infrastructure/api/referrals'
import { useTranslation } from 'react-i18next'
import { ReferralsApiPostReferralRequest } from '@itsrever/rever-api'

export interface ISendReferral {
  group: string
  referrerEmail: string
  referredEmail: string
  referredPhone?: string
  referredBrand?: string
  referredWebsite?: string
}

export function useSendReferral() {
  const { i18n } = useTranslation()
  const language = i18n.language

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)

  async function sendReferral(params: ISendReferral) {
    setIsLoading(true)
    setError(false)
    setSuccess(false)

    try {
      await zapierApi.sendReferral(
        params.group,
        params.referrerEmail,
        params.referredEmail,
        params.referredPhone,
        params.referredBrand,
        params.referredWebsite,
        language
      )

      const args: ReferralsApiPostReferralRequest = {
        referrerGroup: params.group,
        referrerEmail: params.referrerEmail,
        referredEmail: params.referredEmail,
        referredPhone: params.referredPhone,
        referredBrand: params.referredBrand,
        website: params.referredWebsite,
        status: 'PENDING'
      }
      await ReferralsApi.postReferral(args)

      setSuccess(true)
    } catch (err) {
      console.warn(err)
      setError(true)
    } finally {
      setIsLoading(false)
    }
  }

  return { sendReferral, isLoading, error, success }
}
